
// ── HERO FLASHLIGHT REVEAL ──
const heroSec = document.querySelector('.hero');
const hPortrait = document.getElementById('heroPortrait');
const hMask = document.getElementById('heroMask');
if (heroSec && hMask && hPortrait) {
  heroSec.addEventListener('mousemove', e => {
    const r = heroSec.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
    const y = ((e.clientY - r.top)  / r.height * 100).toFixed(1);
    hMask.style.background = `radial-gradient(circle 100px at ${x}% ${y}%, rgba(220,240,255,.1) 0%, transparent 100%), radial-gradient(circle 520px at ${x}% ${y}%, transparent 0%, rgba(2,3,10,.32) 42%, rgba(2,3,10,.92) 100%)`;
    hPortrait.style.opacity = '.62';
  });
  heroSec.addEventListener('mouseleave', () => {
    hMask.style.background = 'radial-gradient(circle 280px at 72% 30%, transparent 0%, rgba(2,3,10,.78) 44%, rgba(2,3,10,.94) 100%)';
    hPortrait.style.opacity = '.22';
  });
}

// ── FLASHLIGHT CURSOR — DISABLED (v15: normal cursor, better scroll perf) ──
const mag   = document.getElementById('magCursor');
const glow  = document.getElementById('flashGlow');
if (mag) mag.style.display = 'none';
if (glow) glow.style.display = 'none';

if (false && mag && glow) {
  const lens = mag.querySelector('.mag-lens');
  let mx=0,my=0,cx=0,cy=0,gx=0,gy=0;

  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;});

  (function loop(){
    cx += (mx-cx)*.28;
    cy += (my-cy)*.28;
    gx += (mx-gx)*.14;
    gy += (my-gy)*.14;

    mag.style.left  = cx+'px';
    mag.style.top   = cy+'px';
    glow.style.left = gx+'px';
    glow.style.top  = gy+'px';
    requestAnimationFrame(loop);
  })();

  document.querySelectorAll('a,button,.polaroid,.nav-links a,.play-btn,.ed-h,.title-main').forEach(el=>{
    el.addEventListener('mouseenter',()=>{
      document.body.classList.add('flash-hover');
      if(!el.closest('.polaroid'))el.style.transform='scale(1.022)';
    });
    el.addEventListener('mouseleave',()=>{
      document.body.classList.remove('flash-hover');
      el.style.transform='';
    });
  });
}

// ── YARN between polaroids ──
function drawYarn(){
  const grid = document.getElementById('evidenceGrid');
  const svg  = document.getElementById('yarnSvg');
  const pols = ['pol1','pol2','pol3'].map(id=>document.getElementById(id));
  if(!grid||!svg||pols.some(p=>!p)) return;

  const gridRect = grid.getBoundingClientRect();
  const scrollY  = window.scrollY;

  // Get pin centers (top-center of each polaroid)
  const centers = pols.map(p=>{
    const r = p.getBoundingClientRect();
    return {
      x: r.left - gridRect.left + r.width/2,
      y: r.top  - gridRect.top  + scrollY + 14
    };
  });

  const h = Math.max(...centers.map(c=>c.y)) + 200;
  svg.style.height = h + 'px';
  svg.setAttribute('viewBox',`0 0 ${grid.offsetWidth} ${h}`);

  // Draw yarn — slightly wavy path between pins
  let paths = '';
  let dots  = '';
  for(let i=0;i<centers.length-1;i++){
    const a=centers[i], b=centers[i+1];
    const mx=(a.x+b.x)/2, my=(a.y+b.y)/2+22;
    paths += `<path d="M${a.x} ${a.y} Q${mx} ${my+18} ${b.x} ${b.y}" stroke="#cc2222" stroke-width="1.2" fill="none" opacity=".25" stroke-dasharray="7,11"/>`;
  }
  // Also draw a line going down off the last card — yarn leads the eye further
  const last = centers[centers.length-1];
  paths += `<path d="M${last.x} ${last.y} Q${last.x+60} ${last.y+80} ${last.x+30} ${last.y+140}" stroke="#cc2222" stroke-width=".8" fill="none" opacity=".15" stroke-dasharray="5,14"/>`;

  centers.forEach((c,i)=>{
    const col = i===1 ? '#c9a84c' : '#00d4e8';
    dots += `<circle cx="${c.x}" cy="${c.y}" r="4" fill="${col}" opacity=".5" filter="url(#glow)"/>`;
  });

  svg.innerHTML = `
    <defs>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="2" result="blur"/>
        <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    ${paths}${dots}`;
}

window.addEventListener('load', drawYarn);
window.addEventListener('resize', drawYarn);

// ── SCROLL REVEAL ──
const ro = new IntersectionObserver(entries=>{
  entries.forEach((e,i)=>{if(e.isIntersecting) setTimeout(()=>e.target.classList.add('visible'),i*55);});
},{threshold:.1});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

// ── SIDE DOTS ──
const dots=document.querySelectorAll('.sn-d');
const secs=document.querySelectorAll('[data-sec]');
const so=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){const i=+e.target.dataset.sec;dots.forEach(d=>d.classList.remove('active'));if(dots[i])dots[i].classList.add('active');}});
},{threshold:.45});
secs.forEach(s=>so.observe(s));

// ── PARALLAX on holo artifacts (scroll-driven slow drift) ──
const artifacts = document.querySelectorAll('.holo-artifact');
window.addEventListener('scroll',()=>{
  const s = window.scrollY;
  artifacts.forEach((a,i)=>{
    const speed = .04 + (i*.015);
    const dir   = i%2===0 ? 1 : -1;
    a.style.transform = `translateY(${s*speed*dir}px)`;
    // Preserve rotation via animation — just add translate
  });
},{passive:true});
